<template>
  <div>
    <div class="card">
      <div class="card-header"><h5>Benutzerverwaltung</h5></div>
      <div class="card-body">
        <b-tabs>
          <b-tab title="Admins">
            <div class="table-responsive datatable-vue">
              <b-table
                show-empty
                :items="admins"
                :fields="tablefields.admins"
                :filter="filter.admins"
                :current-page="currentPage.admins"
                :per-page="perPage"
              >
                <template slot="empty">
                  <div class="text-center">Keine Benutzer gefunden.</div>
                </template>
                <template v-slot:cell(aktionen)="row">
                  <div class="input-group iam-buttons">
                    <div class="moderator-input">
                      <label>Moderator</label>
                      <input type="checkbox" name="moderator_check" :checked="isMod(row.item.id)" @click="toggleMod(row.item)" />
                    </div>
                    <div>
                      <feather
                        :id="'delete-user' + row.item.id"
                        type="trash"
                        size="20"
                        class="infra-blue icon-margin-right pointer"
                        @click="showDeleteUserModal(row.item.id)"
                      ></feather>
                      <b-tooltip :target="'delete-user' + row.item.id" triggers="hover" placement="left">Benutzer löschen</b-tooltip>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </b-tab>
          <b-tab title="Kunden"> </b-tab><!-- TODO: hier wird nichts angezeigt -->
        </b-tabs>
        <b-modal id="deleteUserModal" @ok="deleteUser()" @hide="resetToDelete">
          <div class="card-body">
            <strong>Soll dieser Benutzer endgültig gelöscht werden ?</strong>
          </div>
          <template slot="modal-header"><h5>Benutzer löschen ?</h5> </template>
          <template slot="modal-ok" class="red">Benutzer löschen</template>
          <template slot="modal-cancel">Abbrechen</template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Benutzer",
  components: {},
  data() {
    return {
      admins: [],
      kunden: [],
      toDelete: false,
      tablefields: {
        admins: [
          { key: "last_name", label: "Name", sortable: true },
          { key: "first_name", label: "Vorname", sortable: true },
          { key: "email", label: "email", sortable: true },
          { key: "aktionen", label: "Aktionen", sortable: false },
        ],
      },
      totalRows: {
        admins: 1,
      },
      currentPage: {
        admins: 1,
      },
      perPage: 100,
      filter: {
        admins: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      ready: "app/readyState",
      toasts: "app/toasts",
      animations: "app/animations",
      mods: "chat/mods",
    }),
  },
  async mounted() {},
  async created() {
    await this.getAllUsers();
    await this.$store.dispatch("chat/getMods");
  },
  methods: {
    async getAllUsers() {
      try {
        const responseAdm = await this.$directus.users.readByQuery({
          filter: {
            role: {
              _eq: "0ef37112-08ae-4f6a-b727-12f6b0d8b964", //TODO: role id anpassen füher 1
            },
          },
        });

        const responseKu = await this.$directus.users.readByQuery({
          filter: {
            role: {
              _eq: "f0995ff3-21fd-41a8-91fa-551469b0c5a6", //TODO: role id anpassen früher 3
            },
          },
        });

        this.admins = responseAdm.data.filter((u) => u.email !== "webmaster@iam-design.de");
        this.kunden = responseKu.data;
      } catch (err) {
        this.$toasted.show(err, this.toasts.failure);
      }
    },
    //Release September 2022 START
    isMod(id) {
      const isMod = this.mods.find((m) => m.user.id == id);
      const res = isMod === undefined ? false : true;   
      return res;
    },
    async toggleMod(user) {
      await this.$store.dispatch("chat/getMods");
      const isMod = this.isMod(user.id);
      if (isMod) {
        this.$store.dispatch("chat/unsetMod", user);
      } else {
        this.$store.dispatch("chat/setMod", user);
      }
    },
    //Release September 2022 END
    showDeleteUserModal(userId) {
      this.$bvModal.show("deleteUserModal");
      this.toDelete = userId;
    },
    hideDeleteUserModal() {
      this.$bvModal.hide("deleteUserModal");
      this.toDelete = false;
    },
    resetToDelete() {
      this.toDelete = false;
    },
    async deleteUser() {
      try {
        await this.$directus.users.updateOne(this.toDelete, { status: "deleted" });
        await this.getAllUsers();
      } catch (err) {
        console.log(err);
        this.$toasted.show(err, this.toasts.failure);
      }
    },
  },
};
</script>

<style scoped>
.moderator-input label {
  margin-right: 5px;
}

.moderator-input {
  margin-right: 10px;
}

.moderator-input input {
  position: relative;
  top: 2px;
}
</style>

<style></style>
